export default function parseQuery(query: string) {
    return query.replace(/\/\*[^]*?\*\//g, (str: string) => {
        return str.includes('/*****') && str.includes('*****/') ? '' : str;
    }).trim();
}
